import React from 'react';
import VideoPlayer from '../../components/videoplayer';
import frontendUtils from '../frontendUtils';
import {ACTIONS, EVENTS, STATUS} from 'react-joyride';
import {Trans} from 'react-i18next';
import NextPageButton from './patterns/nextpagebutton';
import smbUtils from '../smbUtils';

const redirectToDocumentCenter = () => {
  window.open(frontendUtils.getDocumentCenterUrl('home-help'));
};

export default {
  steps: {
    addSkuLookTour: [
      {
        target: '.tutorial-sku-creation',
        title: <Trans i18nKey="tutorials.sku.step1.title">SKUs Creation</Trans>,
        content: (
          <Trans i18nKey="tutorials.sku.step1.desc">
            This is your Console.
            <br />
            It’s where you can create, manage, and deploy the AR virtual try-on
            experience for your online shop.
          </Trans>
        ),
        footer: (
          <Trans i18nKey="tutorials.sku.step1.footer">
            In this Demo, You will go to complete the journey creation of a SKU.
            Click “Next” to start it!
          </Trans>
        ),
        disableBeacon: true,
        nextid: 'gtm_start_sku_next_step1',
        endid: 'gtm_start_sku_end_step1',
      },
      {
        target: '.tutorial-add-sku-look-add',
        title: (
          <Trans i18nKey="tutorials.sku.step2.title">
            Create your first AR SKU
          </Trans>
        ),
        content: (
          <Trans i18nKey="tutorials.sku.step2.desc">
            Clicks “Add SKU” under SKUs tag to start creating your first SKU
          </Trans>
        ),
        footer: (
          <a
            href={`https://www.${smbUtils.getDomain()}.com/business/faq#T-ENU-10001`}
            target="_blank"
            className="kt-link"
          >
            <Trans i18nKey="tutorials.product.step6.footer">
              (What is SKU?)
            </Trans>
          </a>
        ),
        disableBeacon: true,
        nextPage: '/products/add-sku?tutorial=true',
        nextid: 'gtm_start_sku_next_step2',
        endid: 'gtm_start_sku_end_step2',
      },
      {
        target: '.tutorial-add-sku-lip-color',
        title: (
          <Trans i18nKey="tutorials.sku.step3.title">
            Create AR Virtual Try On for a Lipstick Product
          </Trans>
        ),
        content: (
          <Trans i18nKey="tutorials.sku.step3.desc">
            In this demo, let’s create a virtual try-on experience for lipstick.
            <br />
            You can later create virtual try-on experiences for other cosmetic
            products yourself.
          </Trans>
        ),
        disableBeacon: true,
        nextid: 'gtm_start_sku_next_step3',
        endid: 'gtm_start_sku_end_step3',
      },
      {
        target: '.tutorial-add-sku-sku-name',
        title: (
          <Trans i18nKey="tutorials.sku.step4.title">Name your AR SKU</Trans>
        ),
        content: (
          <Trans i18nKey="tutorials.sku.step4.desc">
            Simply give a unique name to your AR SKU, so you can find it easily
            later.
          </Trans>
        ),
        disableBeacon: true,
        nextid: 'gtm_start_sku_next_step4',
        endid: 'gtm_start_sku_end_step4',
      },
      {
        target: '.tutorial-add-sku-sku-color',
        title: (
          <Trans i18nKey="tutorials.sku.step5.title">
            Choose a Color for your Lipstick
          </Trans>
        ),
        content: (
          <Trans i18nKey="tutorials.sku.step5.desc">
            Simply use the color spectrum map to choose a shade for you
            lipstick.
            <br />
            Or, use HEX code or RGB color to configure the shade precisely.
          </Trans>
        ),
        footer: (
          <a
            href={`https://www.${smbUtils.getDomain()}.com/business/faq#T-ENU-10002`}
            target="_blank"
            className="kt-link"
          >
            <Trans i18nKey="tutorials.sku.step5.footer">
              (What are HEX and RGB codes?)
            </Trans>
          </a>
        ),
        disableBeacon: true,
        nextid: 'gtm_start_sku_next_step5',
        endid: 'gtm_start_sku_end_step5',
      },
      {
        target: '.tutorial-add-sku-sku-texture',
        title: (
          <Trans i18nKey="tutorials.sku.step6.title">
            Choose a texture for your Lipstick
          </Trans>
        ),
        content: (
          <Trans i18nKey="tutorials.sku.step6.desc">
            Let’s select ‘Matte’ texture to make our lipstick come alive in this
            demo.
          </Trans>
        ),
        // footer: (
        //   <Trans i18nKey="tutorials.sku.step6.footer">
        //     Unfortunately, your paid plan has expired. You can either
        //     re-subscribe to one of our paid plans for more information.
        //   </Trans>
        // ),
        disableBeacon: true,
        nextid: 'gtm_start_sku_next_step6',
        endid: 'gtm_start_sku_end_step6',
      },
      {
        target: '.tutorial-add-sku-sku-colorintensity',
        title: (
          <Trans i18nKey="tutorials.sku.step7.title">
            Tune the Color Intensity
          </Trans>
        ),
        content: (
          <Trans i18nKey="tutorials.sku.step7.desc">
            Move the Color Intensity slider to get the perfect lip color for
            your lipstick.
            <br />
            You can see the change in the ‘Preview’ section.
          </Trans>
        ),
        disableBeacon: true,
        nextid: 'gtm_start_sku_next_step7',
        endid: 'gtm_start_sku_end_step7',
      },
      {
        target: '.tutorial-add-sku-sku-preview',
        title: (
          <Trans i18nKey="tutorials.sku.step8.title">
            Try the AR experience yourself
          </Trans>
        ),
        content: (
          <Trans i18nKey="tutorials.sku.step8.desc">
            You’ve just created your first AR SKU, try it on virtually to see
            the results. You can do this in photo or live video mode.
          </Trans>
        ),
        footer: (
          <Trans i18nKey="tutorials.sku.step8.footer">
            (Please allow access to your camera when trying on in live.)
          </Trans>
        ),
        disableBeacon: true,
        nextid: 'gtm_start_sku_next_step8',
        endid: 'gtm_start_sku_end_step8',
      },
      {
        target: '.tutorial-add-sku-add-button',
        title: (
          <Trans i18nKey="tutorials.sku.step9.title">
            Finish your AR SKU Creation
          </Trans>
        ),
        content: (
          <Trans i18nKey="tutorials.sku.step9.desc">
            Click Add to complete your product creation.
          </Trans>
        ),
        disableBeacon: true,
        nextPage: '/products/list-skus',
        nextid: 'gtm_start_sku_next_step9',
        endid: 'gtm_start_sku_end_step9',
      },
      {
        target: '.tutorial-add-sku-complete',
        title: (
          <Trans i18nKey="tutorials.sku.step10.title">
            Try the AR experience yourself
          </Trans>
        ),
        content: (
          <Trans i18nKey="tutorials.sku.step10.desc">
            You’ve just created your first SKU. You can edit or delete it at any
            time.
          </Trans>
        ),
        footer: (
          <Trans i18nKey="tutorials.sku.step10.footer">
            Click Completed to end Demo SKU Creation journey.
          </Trans>
        ),
        disableBeacon: true,
        nextid: 'gtm_start_sku_complete',
      },
    ],
    productGroupingTour: [
      {
        target: '.tutorial-sku-creation',
        title: (
          <Trans i18nKey="tutorials.product.step1.title">
            Products Grouping
          </Trans>
        ),
        content: (
          <Trans i18nKey="tutorials.product.step1.desc">
            This is your Console. It’s where you can create, manage, and deploy
            the AR virtual try-on experience for your online shop.
          </Trans>
        ),
        footer: (
          <Trans i18nKey="tutorials.product.step1.footer">
            In this Demo, You will go to complete the journey creation of a
            product. Click Next to start your demo Product creation.
          </Trans>
        ),
        disableBeacon: true,
        nextid: 'gtm_start_prodcut_next_step1',
        endid: 'gtm_start_prodcut_end_step1',
      },
      {
        target: '.tutorial-product-grouping-create-products',
        title: (
          <Trans i18nKey="tutorials.product.step2.title">
            Create your first AR SKU
          </Trans>
        ),
        content: (
          <Trans i18nKey="tutorials.product.step2.desc">
            Clicks Create Product under the Products tag to start creating your
            first AR Product.
          </Trans>
        ),
        // footer: (
        //   <Trans i18nKey="tutorials.product.step2.footer">
        //     (What is Product?)
        //   </Trans>
        // ),
        disableBeacon: true,
        nextPage: '/products/add-product',
        nextid: 'gtm_start_prodcut_next_step2',
        endid: 'gtm_start_prodcut_end_step2',
      },
      {
        target: '.tutorial-product-grouping-create-products-category',
        title: (
          <Trans i18nKey="tutorials.product.step3.title">
            Select a product type from the Category list
          </Trans>
        ),
        content: (
          <Trans i18nKey="tutorials.product.step3.desc">
            In this demo, we’ll create a Lipstick Product.
            <br />
            You can create other Product yourself later.
          </Trans>
        ),
        disableBeacon: true,
        nextid: 'gtm_start_prodcut_next_step3',
        endid: 'gtm_start_prodcut_end_step3',
      },
      {
        target: '.tutorial-product-grouping-create-products-productname',
        title: (
          <Trans i18nKey="tutorials.product.step4.title">
            Give Your Product a Name
          </Trans>
        ),
        content: (
          <Trans i18nKey="tutorials.product.step4.desc">
            Simply give a unique name to your AR Product, so you can find it
            easily later.
            <br />
            Let’s type Perfect Lipstick here.
          </Trans>
        ),
        disableBeacon: true,
        nextid: 'gtm_start_prodcut_next_step4',
        endid: 'gtm_start_prodcut_end_step4',
      },
      {
        target: '.tutorial-product-grouping-create-products-image',
        title: (
          <Trans i18nKey="tutorials.product.step5.title">
            Upload an image for your AR Product
          </Trans>
        ),
        content: (
          <Trans i18nKey="tutorials.product.step5.desc">
            A Product image will be shown when your customer is trying on the
            module.
            <br />
            Let’s upload a photo for the lipstick.
          </Trans>
        ),
        footer: (
          <Trans i18nKey="tutorials.product.step5.footer">
            We’ve uploaded a sample image for you in this demo.
          </Trans>
        ),
        disableBeacon: true,
        nextid: 'gtm_start_prodcut_next_step5',
        endid: 'gtm_start_prodcut_end_step5',
      },
      {
        target: '.tutorial-product-grouping-products-grouping',
        title: (
          <Trans i18nKey="tutorials.product.step6.title">
            Add SKU into your Product
          </Trans>
        ),
        content: (
          <Trans i18nKey="tutorials.product.step6.desc">
            Clicks Add SKU to start grouping SKUs into a Product.
          </Trans>
        ),
        footer: (
          <a
            href={`https://www.${smbUtils.getDomain()}.com/faq#T-ENU-10001`}
            target="_blank"
            className="kt-link"
          >
            <Trans i18nKey="tutorials.product.step6.footer">
              (What is SKU?)
            </Trans>
          </a>
        ),
        disableBeacon: true,
        nextid: 'gtm_start_prodcut_next_step6',
        endid: 'gtm_start_prodcut_end_step6',
      },
      {
        target: '.tutorial-product-grouping-create-products-choose-skus',
        title: (
          <Trans i18nKey="tutorials.product.step7.title">
            Choose right SKUs for your Product
          </Trans>
        ),
        content: (
          <Trans i18nKey="tutorials.product.step7.desc">
            We’ve created a few SKUs for you.
            <br />
            Remember to select SKUs for the corresponding Product.
            <br />
            Let’s choose SKUs for perfect lipstick
          </Trans>
        ),
        footer: (
          <Trans i18nKey="tutorials.product.step7.footer">
            (If there is no Lip Color SKU can choose, please{' '}
            <a href="/products/list-skus" className="kt-link">
              Create SKU
            </a>{' '}
            first.)
          </Trans>
        ),
        disableBeacon: true,
        nextid: 'gtm_start_prodcut_next_step7',
        endid: 'gtm_start_prodcut_end_step7',
      },
      {
        target: '.tutorial-product-grouping-products-creations',
        title: (
          <Trans i18nKey="tutorials.product.step8.title">
            Finish your AR Product Creation
          </Trans>
        ),
        content: (
          <Trans i18nKey="tutorials.product.step8.desc">
            Click Add to complete your AR Product Creation.
          </Trans>
        ),
        disableBeacon: true,
        nextPage: '/products/list-products',
        nextid: 'gtm_start_prodcut_next_step8',
        endid: 'gtm_start_prodcut_end_step8',
      },
      {
        target: '.tutorial-add-product-complete',
        title: (
          <Trans i18nKey="tutorials.product.step9.title">
            Adjust your AR Product at any time
          </Trans>
        ),
        content: (
          <Trans i18nKey="tutorials.product.step9.desc">
            You’ve just created your first AR Product.
            <br />
            You can edit or delete it at anytime.
          </Trans>
        ),
        footer: (
          <Trans i18nKey="tutorials.product.step9.footer">
            Click Completed to end Demo Product Grouping journey.{' '}
          </Trans>
        ),
        disableBeacon: true,
        nextid: 'gtm_start_prodcut_next_step9',
        endid: 'gtm_start_prodcut_end_step9',
      },
    ],
    moduleConfigurationTour: [
      {
        target: '.tutorial-config-module',
        title: (
          <Trans i18nKey="tutorials.steps.module.configuration.title">
            Module Configuration
          </Trans>
        ),
        content: (
          <Trans i18nKey="tutorials.steps.module.configuration.desc">
            Set up the watermark, layout, model, and more advanced
            configurations for your module.
          </Trans>
        ),
        disableBeacon: true,
      },
      {
        target: '.nav-link.active',
        title: (
          <Trans i18nKey="tutorials.steps.module.configuration.layout.title">
            Layout Settings
          </Trans>
        ),
        content: (
          <Trans i18nKey="tutorials.steps.module.configuration.layout.desc">
            There are three layouts for you to choose from (according to your
            subscription plan) and you can set the background to customize the
            style of your website.
          </Trans>
        ),
        disableBeacon: true,
      },
      {
        target: '.tutorial-config-module-model',
        title: (
          <Trans i18nKey="tutorials.steps.module.configuration.model.title">
            Model Settings
          </Trans>
        ),
        content: (
          <Trans i18nKey="tutorials.steps.module.configuration.model.desc">
            You can upload up to 6 custom model photos. If no photos are
            uploaded, the default model photos will be used.
          </Trans>
        ),
        disableBeacon: true,
      },
      {
        target: '.nav-link.active',
        title: (
          <Trans i18nKey="tutorials.steps.module.configuration.advanced.title">
            Advanced Settings
          </Trans>
        ),
        content: (
          <Trans i18nKey="tutorials.steps.module.configuration.advanced.desc">
            There are several advanced settings for you to adjust, such as
            enabling model photo, 2 color comparison, and photo sharing.
          </Trans>
        ),
        disableBeacon: true,
      },
    ],
    apiIntegrationTour: [
      {
        target: '.tutorial-integrate-api',
        title: (
          <Trans i18nKey="tutorials.steps.api.integration.key.title">
            API Key
          </Trans>
        ),
        content: (
          <div>
            <Trans i18nKey="tutorials.steps.api.integration.key.desc">
              Use this API key to identify your module and keep it safe. Learn
              more about using APIs{' '}
              <a
                href="javascript:;"
                onClick={redirectToDocumentCenter}
                target="_blank"
                rel="noreferrer noopener"
                style={{color: 'pink'}}
              >
                here
              </a>
              .
            </Trans>
          </div>
        ),
        disableBeacon: true,
      },
    ],
    analyticsTour: [
      {
        target: '.tutorial-analytics',
        title: (
          <Trans i18nKey="tutorials.steps.analytics.title">Analytics</Trans>
        ),
        content: (
          <div>
            <div style={{paddingBottom: '10px'}}>
              <Trans i18nKey="tutorials.steps.analytics.desc">
                We provide you with valuable insights that can be used to
                improve the performance of your website and increase
                conversions.
              </Trans>
            </div>
            <VideoPlayer
              videoUrl="https://www.youtube.com/embed/vAbfl78mPys"
              videoCover={require('../../assets/images/tutorial/video_cover_analytics.jpg')}
            />
          </div>
        ),
        placement: 'center',
        disableBeacon: true,
        hideFooter: true,
        styles: {
          options: {
            width: 800,
          },
        },
      },
    ],
    addEyewearProductTour: [
      {
        target: '.tutorial-sku-creation',
        title: (
          <Trans i18nKey="tutorials.eyewear.product.step1.title">
            Creating a Eyewear Product
          </Trans>
        ),
        content: (
          <Trans i18nKey="tutorials.eyewear.product.step1.desc">
            This is your console - a place where you can create, manage, and
            deploy all your digital products, and enable virtual try-on for your
            online shop.
          </Trans>
        ),
        footer: (
          <Trans i18nKey="tutorials.eyewear.product.step1.footer">
            Click the <strong>'Next'</strong> button below to begin the demo,
            and learn how to create a virtual eyewear product.
          </Trans>
        ),
        disableBeacon: true,
        nextid: 'gtm_start_prodcut_next_step1',
        endid: 'gtm_start_prodcut_end_step1',
      },
      {
        target: '.tutorial-add-eyewear-product',
        title: (
          <Trans i18nKey="tutorials.eyewear.product.step2.title">
            Getting Started
          </Trans>
        ),
        content: (
          <Trans i18nKey="tutorials.eyewear.product.step2.desc">
            Click <strong>'Add Product'</strong> button to begin creating a
            virtual eyewear product.
          </Trans>
        ),
        disableBeacon: true,
        nextPage: '/eyewear/add-product?mode=eyewear-product',
        nextid: 'gtm_start_prodcut_next_step2',
        endid: 'gtm_start_prodcut_end_step2',
      },
      {
        target: '.tutorial-add-eyewear-product-category-tag',
        title: (
          <Trans i18nKey="tutorials.eyewear.product.step3.title">
            Selecting a Category Tag for your New Product
          </Trans>
        ),
        content: (
          <Trans i18nKey="tutorials.eyewear.product.step3.desc">
            For the purposes of this demo, we will add our new product under the
            category. You can experiment with other tags on your own.
          </Trans>
        ),
        disableBeacon: true,
        nextid: 'gtm_start_prodcut_next_step3',
        endid: 'gtm_start_prodcut_end_step3',
      },
      {
        target: '.tutorial-add-eyewear-product-name-image',
        title: (
          <Trans i18nKey="tutorials.eyewear.product.step4.title">
            Filling in Product Information
          </Trans>
        ),
        content: (
          <Trans i18nKey="tutorials.eyewear.product.step4.desc">
            Please provide a unique name and Image for your virtual eyewear
            product.
          </Trans>
        ),
        disableBeacon: true,
        nextid: 'gtm_start_prodcut_next_step4',
        endid: 'gtm_start_prodcut_end_step4',
      },
      {
        target: '.tutorial-add-eyewear-product-choose-frame',
        title: (
          <Trans i18nKey="tutorials.eyewear.product.step5.title">
            Choose Frames into your Product
          </Trans>
        ),
        content: (
          <Trans i18nKey="tutorials.eyewear.product.step5.desc">
            Click <strong>‘Choose Frame’</strong> to add Frame into your
            Product.
          </Trans>
        ),
        disableBeacon: true,
        nextid: 'gtm_start_prodcut_next_step5',
        endid: 'gtm_start_prodcut_end_step5',
      },
      {
        target: '.tutorial-add-eyewear-product-choose-frame-modal',
        title: (
          <Trans i18nKey="tutorials.eyewear.product.step6.title">
            Choose Frames
          </Trans>
        ),
        content: (
          <Trans i18nKey="tutorials.eyewear.product.step6.desc">
            Choose Frame which you have created in Frame Management.
            <br />
            Click <strong>'Choose'</strong> to save the result.
          </Trans>
        ),
        disableBeacon: true,
        nextid: 'gtm_start_prodcut_next_step6',
        endid: 'gtm_start_prodcut_end_step6',
      },
      {
        target: '.tutorial-add-eyewear-product-choose-frame-form',
        title: (
          <Trans i18nKey="tutorials.eyewear.product.step7.title">
            Reviewing Existing Virtual Frame
          </Trans>
        ),
        content: (
          <Trans i18nKey="tutorials.eyewear.product.step7.desc">
            After choosing Frame, you can see a list of your frame in the table.
          </Trans>
        ),
        disableBeacon: true,
        nextid: 'gtm_start_prodcut_next_step7',
        endid: 'gtm_start_prodcut_end_step7',
      },
      {
        target: '.tutorial-add-eyewear-product-save-button',
        title: (
          <Trans i18nKey="tutorials.eyewear.product.step8.title">
            Saving the Virtual Eyewear Product
          </Trans>
        ),
        content: (
          <Trans i18nKey="tutorials.eyewear.product.step8.desc">
            Click <strong>'Save'</strong> to complete creating a virtual
            product.
          </Trans>
        ),
        disableBeacon: true,
        nextid: 'gtm_start_prodcut_next_step8',
        endid: 'gtm_start_prodcut_end_step8',
        nextPage: '/eyewear/list-products?mode=eyewear-product',
      },
      {
        target: '.tutorial-add-eyewear-product-list-page',
        title: (
          <Trans i18nKey="tutorials.eyewear.product.step9.title">
            Reviewing Existing Virtual Eyewear Products
          </Trans>
        ),
        content: (
          <Trans i18nKey="tutorials.eyewear.product.step9.desc">
            After completing the setup process, you can see a list of your
            virtual products in the table.
          </Trans>
        ),
        disableBeacon: true,
        nextid: 'gtm_start_prodcut_next_step9',
        endid: 'gtm_start_prodcut_end_step9',
      },
      {
        target: '.tutorial-add-eyewear-product-list-page-action-button',
        title: (
          <Trans i18nKey="tutorials.eyewear.product.step10.title">
            Adjust your AR Eyewear at any time
          </Trans>
        ),
        content: (
          <Trans i18nKey="tutorials.eyewear.product.step10.desc">
            You’ve just created your first AR Eyewear Product. You can edit or
            delete it at anytime.
          </Trans>
        ),
        disableBeacon: true,
        nextid: 'gtm_start_prodcut_next_step10',
      },
    ],
    addEyewearFrameTour: [
      {
        target: '.tutorial-add-frame-management-button',
        title: (
          <Trans i18nKey="tutorials.eyewear.frame.step1.title">
            Creating a New Frame
          </Trans>
        ),
        content: (
          <Trans i18nKey="tutorials.eyewear.frame.step1.desc">
            Click <strong>'Frame Management'</strong> button to manage all your
            Frame include make a New Frame.
          </Trans>
        ),
        disableBeacon: true,
        nextPage: '/eyewear/list-frame?mode=eyewear-frame',
        nextid: 'gtm_start_frame_next_step1',
        endid: 'gtm_start_frame_end_step1',
      },
      {
        target: '.tutorial-add-frame-button',
        title: (
          <Trans i18nKey="tutorials.eyewear.frame.step2.title">
            Creating a Virtual Frame
          </Trans>
        ),
        content: (
          <Trans i18nKey="tutorials.eyewear.frame.step2.desc">
            Click the 'Add Frame' button to begin.
          </Trans>
        ),
        disableBeacon: true,
        nextPage: '/eyewear/add-frame?mode=eyewear-frame',
        nextid: 'gtm_start_frame_next_step2',
        endid: 'gtm_start_frame_end_step2',
      },
      {
        target: '.tutorial-add-eyewear-frame-frame-name',
        title: (
          <Trans i18nKey="tutorials.eyewear.frame.step3.title">
            Name your AR Frame
          </Trans>
        ),
        content: (
          <Trans i18nKey="tutorials.eyewear.frame.step3.desc">
            Provide a unique name for each AR product. You may wish for this
            name to correspond to the commercially available name you use for
            this product in other areas.
          </Trans>
        ),
        disableBeacon: true,
        nextid: 'gtm_start_frame_next_step3',
        endid: 'gtm_start_frame_end_step3',
      },
      {
        target: '.tutorial-add-eyewear-frame-frame-image',
        title: (
          <Trans i18nKey="tutorials.eyewear.frame.step4.title">
            Uploading a Flat Product Image
          </Trans>
        ),
        content: (
          <Trans i18nKey="tutorials.eyewear.frame.step4.desc">
            A flat product image will be shown to your customers before
            launching the virtual try-on experience.
          </Trans>
        ),
        disableBeacon: true,
        nextid: 'gtm_start_frame_next_step4',
        endid: 'gtm_start_frame_end_step4',
      },
      {
        target: '.tutorial-add-eyewear-frame-shop-url',
        title: (
          <Trans i18nKey="tutorials.eyewear.frame.step5.title">
            Adding a Link to Purchase a Product
          </Trans>
        ),
        content: (
          <Trans i18nKey="tutorials.eyewear.frame.step5.desc">
            Enable your customers to add a product to their shopping cart with
            one click.
            <br />
            Provide a corresponding link to be added to the Shop Now! button.
          </Trans>
        ),
        disableBeacon: true,
        nextid: 'gtm_start_frame_next_step5',
        endid: 'gtm_start_frame_end_step5',
      },
      {
        target: '.tutorial-add-eyewear-frame-frame-design',
        title: (
          <Trans i18nKey="tutorials.eyewear.frame.step6.title">
            Uploading a Frame Design
          </Trans>
        ),
        content: (
          <Trans i18nKey="tutorials.eyewear.frame.step6.desc">
            Building a virtual try-on experience for an Frame requires uploading
            3 flat images of a frame with transparent backgrounds.
            <br />
            This includes both left and right temples, and the front of the
            frame.
            <br />
            Use the <strong>Dot Location</strong> to make the virtual try-on
            effect more precise.
          </Trans>
        ),
        footer: (
          <Trans i18nKey="tutorials.eyewear.frame.step6.footer">
            Please refer to the image specification guide for more information
            on building a virtual twin of your Frame.
          </Trans>
        ),
        disableBeacon: true,
        nextid: 'gtm_start_frame_next_step6',
        endid: 'gtm_start_frame_end_step6',
      },
      // {
      //   target: '.tutorial-add-eyewear-frame-size-position-reflection',
      //   title: (
      //     <Trans i18nKey="tutorials.eyewear.frame.step7.title">
      //       Adjusting a Virtual Product
      //     </Trans>
      //   ),
      //   content: (
      //     <Trans i18nKey="tutorials.eyewear.frame.step7.desc">
      //       Use the additional options to further customize each product.
      //     </Trans>
      //   ),
      //   disableBeacon: true,
      //   nextid: 'gtm_start_sku_next_step7',
      //   endid: 'gtm_start_sku_end_step7',
      // },
      {
        target: '.tutorial-add-eyewear-frame-save-button',
        title: (
          <Trans i18nKey="tutorials.eyewear.frame.step8.title">
            Saving a Virtual Frame
          </Trans>
        ),
        content: (
          <Trans i18nKey="tutorials.eyewear.frame.step8.desc">
            Click <strong>'Save'</strong> to complete creating a virtual Frame.
          </Trans>
        ),
        disableBeacon: true,
        nextid: 'gtm_start_frame_next_step7',
        endid: 'gtm_start_frame_end_step7',
        nextPage: '/eyewear/list-frame?mode=eyewear-frame',
      },
      {
        target: '.tutorial-add-eyewear-frame-list-page',
        title: (
          <Trans i18nKey="tutorials.eyewear.frame.step9.title">
            Reviewing Existing Virtual Frame
          </Trans>
        ),
        content: (
          <Trans i18nKey="tutorials.eyewear.frame.step9.desc">
            After completing the Frame creation, you can see a list of your
            frame in the table.
          </Trans>
        ),
        disableBeacon: true,
        nextid: 'gtm_start_frame_next_step8',
        endid: 'gtm_start_frame_end_step8',
      },
      {
        target: '.tutorial-add-eyewear-frame-list-page-action-button',
        title: (
          <Trans i18nKey="tutorials.eyewear.frame.step10.title">
            Adjust your AR Eyewear at any time
          </Trans>
        ),
        content: (
          <Trans i18nKey="tutorials.eyewear.frame.step10.desc">
            You’ve just created your AR Frame.
            <br />
            You can edit or delete it at anytime.
          </Trans>
        ),
        disableBeacon: true,
        nextid: 'gtm_start_frame_next_step9',
      },
    ],
    addEyewearLensTintTour: [
      {
        target: '.tutorial-add-lens-tint-step1',
        title: (
          <Trans i18nKey="tutorials.eyewear.lens.tint.step1.title">
            Match Lens Tint & Size
          </Trans>
        ),
        content: (
          <Trans i18nKey="tutorials.eyewear.lens.tint.step1.desc">
            Frame can match some different Lens or Size to Calculating multiple
            SKUs
            <br /> Click <strong>'Frame Management'</strong> button to begin.
          </Trans>
        ),
        disableBeacon: true,
        nextPage: '/eyewear/list-frame?mode=eyewear-lenstint',
        nextid: 'gtm_start_lens_next_step1',
        endid: 'gtm_start_lens_end_step1',
      },
      {
        target: '.tutorial-add-lens-tint-step2',
        title: (
          <Trans i18nKey="tutorials.eyewear.lens.tint.step2.title">
            Creating a Virtual Frame
          </Trans>
        ),
        content: (
          <Trans i18nKey="tutorials.eyewear.lens.tint.step2.desc">
            Click the <strong>'Add Frame'</strong> button to begin.{' '}
          </Trans>
        ),
        disableBeacon: true,
        nextPage: '/eyewear/add-frame?mode=eyewear-lenstint',
        nextid: 'gtm_start_lens_next_step2',
        endid: 'gtm_start_lens_end_step2',
      },
      {
        target: '.tutorial-add-lens-tint-step3',
        title: (
          <Trans i18nKey="tutorials.eyewear.lens.tint.step3.title">
            Filling in Product Information
          </Trans>
        ),
        content: (
          <Trans i18nKey="tutorials.eyewear.lens.tint.step3.desc">
            Fill in the relevant product information, before providing the size
            and lens tint options.
          </Trans>
        ),
        disableBeacon: true,
        nextid: 'gtm_start_lens_next_step3',
        endid: 'gtm_start_lens_end_step3',
      },
      {
        target: '.tutorial-add-lens-tint-step4',
        title: (
          <Trans i18nKey="tutorials.eyewear.lens.tint.step4.title">
            Uploading a Frame Design
          </Trans>
        ),
        content: (
          <Trans i18nKey="tutorials.eyewear.lens.tint.step4.desc">
            Building a virtual try-on experience for an Frame requires uploading
            3 flat images of a frame with transparent backgrounds.
            <br />
            This includes both left and right temples, and the front of the
            frame.
            <br />
            Use the Dot Location to make the virtual try-on effect more precise.
          </Trans>
        ),
        footer: (
          <Trans i18nKey="tutorials.eyewear.lens.tint.step4.footer">
            Please refer to the image specification guide for more information
            on building a virtual twin of your Frame.
          </Trans>
        ),
        disableBeacon: true,
        nextid: 'gtm_start_lens_next_step4',
        endid: 'gtm_start_lens_end_step4',
      },
      {
        target: '.tutorial-add-lens-tint-step5',
        title: (
          <Trans i18nKey="tutorials.eyewear.lens.tint.step5.title">
            Uploading a Lens Mask
          </Trans>
        ),
        content: (
          <Trans i18nKey="tutorials.eyewear.lens.tint.step5.desc">
            We will present different color effects according to the area of the
            Lens Mask
          </Trans>
        ),
        footer: (
          <Trans i18nKey="tutorials.eyewear.lens.tint.step5.footer">
            Please refer to the image specification guide for more information
            on building a virtual twin of your Frame.
          </Trans>
        ),
        disableBeacon: true,
        nextid: 'gtm_start_lens_next_step5',
        endid: 'gtm_start_lens_end_step5',
      },
      {
        target: '.tutorial-add-lens-tint-step6',
        title: (
          <Trans i18nKey="tutorials.eyewear.lens.tint.step6.title">
            Choose Lens Tint Options
          </Trans>
        ),
        content: (
          <Trans i18nKey="tutorials.eyewear.lens.tint.step6.desc">
            Click the <strong>'Choose Lens Tint'</strong> button to add all the
            available lens colors for each product.
          </Trans>
        ),
        disableBeacon: true,
        nextid: 'gtm_start_lens_next_step6',
        endid: 'gtm_start_lens_end_step6',
      },
      {
        target: '.tutorial-add-lens-tint-step7',
        title: (
          <Trans i18nKey="tutorials.eyewear.lens.tint.step7.title">
            Choose Lens Tint
          </Trans>
        ),
        content: (
          <Trans i18nKey="tutorials.eyewear.lens.tint.step7.desc">
            Select all the lens tints available for each product.
            <br />
            Original is your original Lens color by your image, and you can make
            solid and gradient color as you want.
          </Trans>
        ),
        footer: (
          <Trans i18nKey="tutorials.eyewear.lens.tint.step7.footer">
            To create additional lens tints, please click the{' '}
            <strong>'Create more Lens Tint'</strong> button.
          </Trans>
        ),
        disableBeacon: true,
        nextid: 'gtm_start_lens_next_step7',
        endid: 'gtm_start_lens_end_step7',
      },
      {
        target: '.tutorial-add-lens-tint-step8',
        title: (
          <Trans i18nKey="tutorials.eyewear.lens.tint.step8.title">
            Saving Lens Tint
          </Trans>
        ),
        content: (
          <Trans i18nKey="tutorials.eyewear.lens.tint.step8.desc">
            Click <strong>'Save'</strong> to finish the your choosing.
          </Trans>
        ),
        disableBeacon: true,
        nextid: 'gtm_start_lens_next_step8',
        endid: 'gtm_start_lens_end_step8',
      },
      {
        target: '.tutorial-add-lens-tint-step9',
        title: (
          <Trans i18nKey="tutorials.eyewear.lens.tint.step9.title">
            Choose Frame Size Options
          </Trans>
        ),
        content: (
          <Trans i18nKey="tutorials.eyewear.lens.tint.step9.desc">
            If your frame is available in various sizes, there are 5 variations
            to choose from.
            <br />
            Each virtual frame is created in size <strong>M</strong> by default.
          </Trans>
        ),
        disableBeacon: true,
        nextid: 'gtm_start_lens_next_step9',
        endid: 'gtm_start_lens_end_step9',
      },
      {
        target: '.tutorial-add-lens-tint-step10',
        title: (
          <Trans i18nKey="tutorials.eyewear.lens.tint.step10.title">
            Adjusting Frame Width and Size Availability
          </Trans>
        ),
        content: (
          <Trans i18nKey="tutorials.eyewear.lens.tint.step10.desc">
            Customize the frame width by changing the value provided in
            millimeters.
            <br />
            Adjust the availability of each size at any time.
          </Trans>
        ),
        disableBeacon: true,
        nextid: 'gtm_start_lens_next_step10',
        endid: 'gtm_start_lens_end_step10',
      },
      {
        target: '.tutorial-add-lens-tint-step11',
        title: (
          <Trans i18nKey="tutorials.eyewear.lens.tint.step11.title">
            Saving Size and Lens Tint
          </Trans>
        ),
        content: (
          <Trans i18nKey="tutorials.eyewear.lens.tint.step11.desc">
            Click <strong>'Save'</strong> to finish the setup process.
          </Trans>
        ),
        disableBeacon: true,
        nextid: 'gtm_start_lens_next_step11',
        endid: 'gtm_start_lens_end_step11',
      },
      {
        target: '.tutorial-add-lens-tint-step12',
        title: (
          <Trans i18nKey="tutorials.eyewear.lens.tint.step12.title">
            Calculating SKUs
          </Trans>
        ),
        content: (
          <Trans i18nKey="tutorials.eyewear.lens.tint.step12.desc">
            Each new lens tint and size options are created as new and separate
            SKUs.
            <br />
            Please take this into account when configuring product variations.
          </Trans>
        ),
        disableBeacon: true,
        nextid: 'gtm_start_lens_next_step12',
        endid: 'gtm_start_lens_end_step12',
      },
      {
        target: '.tutorial-add-lens-tint-step13',
        title: (
          <Trans i18nKey="tutorials.eyewear.lens.tint.step13.title">
            Confirming the New SKUs
          </Trans>
        ),
        content: (
          <Trans i18nKey="tutorials.eyewear.lens.tint.step13.desc">
            Click <strong>'Confirm'</strong> to add the newly-created SKUs to
            your available products.
          </Trans>
        ),
        disableBeacon: true,
        nextid: 'gtm_start_lens_next_step13',
        endid: 'gtm_start_lens_end_step13',
        nextPage: '/eyewear/list-frame?mode=eyewear-lenstint',
      },
      {
        target: '.tutorial-add-lens-tint-step14',
        title: (
          <Trans i18nKey="tutorials.eyewear.lens.tint.step14.title">
            Reviewing Existing Virtual Frame
          </Trans>
        ),
        content: (
          <Trans i18nKey="tutorials.eyewear.lens.tint.step14.desc">
            After completing the Frame creation, you can see a list of your
            frame in the table.
          </Trans>
        ),
        disableBeacon: true,
        nextid: 'gtm_start_lens_next_step14',
        endid: 'gtm_start_lens_end_step14',
      },
      {
        target: '.tutorial-add-lens-tint-step15',
        title: (
          <Trans i18nKey="tutorials.eyewear.lens.tint.step15.title">
            Adjusting SKUs and Settings
          </Trans>
        ),
        content: (
          <Trans i18nKey="tutorials.eyewear.lens.tint.step15.desc">
            You can go back and delete or adjust settings of any virtual product
            and associated options at any time.
          </Trans>
        ),
        disableBeacon: true,
        nextid: 'gtm_start_lens_next_step15',
      },
    ],
  },
  startGuideTour: [
    {
      target: '.tutorial-start-guide',
      content: (
        <Trans i18nKey="tutorials.steps.start.guide.open.desc">
          You can open and view start guide here.
        </Trans>
      ),
      disableBeacon: true,
      hideFooter: true,
      buttonText: <Trans i18nKey="tutorials.tooltip.done">Done</Trans>,
    },
  ],
  skincareStartGuideTour: [
    {
      target: '.tutorial-skincare-start-guide',
      title: (
        <Trans i18nKey="tutorials.steps.start.guide.open.title">Welcome!</Trans>
      ),
      content: (
        <Trans i18nKey="tutorials.skincare.start.guide.open.desc">
          To get started with Skincare Pro, please check out the&nbsp;
          <strong>Start Guide</strong>&nbsp;here for step-by-step instructions.
        </Trans>
      ),
      disableBeacon: true,
      placement: 'left',
      hideFooter: true,
    },
  ],
  startGuideTourCallback: hideTourHint => data => {
    const {status} = data;
    if (STATUS.FINISHED === status) {
      hideTourHint();
    }
  },
  stepStyles: {
    options: {
      arrowColor: '#5d77ff',
      zIndex: 1200,
    },
  },
  stepsCallback: {
    addSkuLookTour: (openTour, nextStep, tourTaskFinished) => data => {
      const {action, type, status, index} = data;
      if ([EVENTS.STEP_AFTER, EVENTS.TARGET_NOT_FOUND].includes(type)) {
        if (ACTIONS.CLOSE === action) {
          openTour();
        } else {
          nextStep();
        }
      } else if (STATUS.FINISHED === status) {
        tourTaskFinished('ADD_SKU_LOOK_TOUR_VIEWED');
        openTour();
      }
    },
    productGroupingTour: (openTour, nextStep, tourTaskFinished) => data => {
      const {action, type, status} = data;
      if ([EVENTS.STEP_AFTER, EVENTS.TARGET_NOT_FOUND].includes(type)) {
        if (ACTIONS.CLOSE === action) {
          openTour();
        } else {
          nextStep();
        }
      } else if (STATUS.FINISHED === status) {
        tourTaskFinished('PRODUCT_GROUP_TOUR_VIEWED');
        openTour();
      }
    },
    moduleConfigurationTour: (
      openTour,
      nextStep,
      tourTaskFinished,
      setCurrentTabKey,
      functionType
    ) => data => {
      const {action, index, type, status} = data;
      if ([EVENTS.STEP_AFTER, EVENTS.TARGET_NOT_FOUND].includes(type)) {
        if (ACTIONS.CLOSE === action) {
          openTour();
        } else {
          nextStep();
          if (index === 0) setCurrentTabKey('L');
          else if (index === 2) {
            setCurrentTabKey('A');
            window.scrollTo(0, 0);
          }
        }
      } else if (STATUS.FINISHED === status) {
        tourTaskFinished(
          functionType === 'EYEWEAR'
            ? 'MODULE_CONFIGURATION_TOUR_EYEWEAR_VIEWED'
            : 'MODULE_CONFIGURATION_TOUR_VIEWED'
        );
        openTour();
      }
    },
    apiIntegrationTour: (
      openTour,
      nextStep,
      tourTaskFinished,
      functionType
    ) => data => {
      const {type, status} = data;
      if ([EVENTS.STEP_AFTER, EVENTS.TARGET_NOT_FOUND].includes(type)) {
        nextStep();
      } else if (STATUS.FINISHED === status) {
        tourTaskFinished(
          functionType === 'EYEWEAR'
            ? 'API_INTEGRATION_TOUR_EYEWEAR_VIEWED'
            : 'API_INTEGRATION_TOUR_VIEWED'
        );
        openTour();
      }
    },
    analyticsTour: (
      openTour,
      nextStep,
      tourTaskFinished,
      functionType
    ) => data => {
      const {type, status} = data;
      if ([EVENTS.STEP_AFTER, EVENTS.TARGET_NOT_FOUND].includes(type)) {
        nextStep();
      } else if (STATUS.FINISHED === status) {
        tourTaskFinished(
          functionType === 'EYEWEAR'
            ? 'ANALYTICS_TOUR_EYEWEAR_VIEWED'
            : 'ANALYTICS_TOUR_VIEWED'
        );
        openTour();
      }
    },
    addEyewearProductTour: (
      openTour,
      nextStep,
      tourTaskFinished,
      closeModal
    ) => data => {
      const {action, type, status, index} = data;
      if ([EVENTS.STEP_AFTER, EVENTS.TARGET_NOT_FOUND].includes(type)) {
        if (ACTIONS.CLOSE === action) {
          closeModal();
          openTour();
        } else {
          nextStep();
        }
      } else if (STATUS.FINISHED === status) {
        tourTaskFinished('PRODUCT_EYEWEAR_TOUR_VIEWED');
        openTour();
      }
    },
    addEyewearFrameTour: (openTour, nextStep, tourTaskFinished) => data => {
      const {action, type, status, index} = data;
      if ([EVENTS.STEP_AFTER, EVENTS.TARGET_NOT_FOUND].includes(type)) {
        if (ACTIONS.CLOSE === action) {
          openTour();
        } else {
          nextStep();
        }
      } else if (STATUS.FINISHED === status) {
        tourTaskFinished('ADD_EYEWEAR_FRAME_TOUR_VIEWED');
        openTour();
      }
    },
    addEyewearLensTintTour: (
      openTour,
      nextStep,
      tourTaskFinished,
      closeModal
    ) => data => {
      const {action, type, status, index} = data;
      if ([EVENTS.STEP_AFTER, EVENTS.TARGET_NOT_FOUND].includes(type)) {
        if (ACTIONS.CLOSE === action) {
          closeModal();
          openTour();
        } else {
          nextStep();
        }
      } else if (STATUS.FINISHED === status) {
        tourTaskFinished('LENS_TINT_EYEWEAR_TOUR_VIEWED');
        openTour();
      }
    },
  },
  customToolTip: ({
    index,
    size,
    step,
    closeProps,
    primaryProps,
    tooltipProps,
    nextStep,
  }) => {
    const currentStep = index + 1;
    const isLast = currentStep === size;
    return (
      <div
        {...tooltipProps}
        className="tutorial-tooltip"
        style={{width: step.styles.options.width && step.styles.options.width}}
      >
        <div className="tutorial-tooltip-content">
          {step.title && (
            <div className="tutorial-tooltip-content_title">{step.title}</div>
          )}
          {step.showProgress && (
            <div className="tutorial-tooltip-footer_progress">
              <Trans i18nKey="tutorials.tooltip.progress">
                Step {{currentStep}} of {{size}}
              </Trans>
            </div>
          )}
        </div>

        {step.content && (
          <div className="tutorial-tooltip-content_desc">{step.content}</div>
        )}

        {step.footer && (
          <div className="tutorial-tooltip-content_footer">{step.footer}</div>
        )}
        <div className="tutorial-tooltip-footer">
          {!isLast && (
            <div
              className="tutorial-tooltip-footer_end kt-link"
              {...closeProps}
              id={step.endid}
            >
              <Trans i18nKey="tutorials.tooltip.end">End Demo</Trans>
            </div>
          )}
          {step.nextPage ? (
            <NextPageButton link={step.nextPage} id={step.nextid} />
          ) : (
            <button
              type="button"
              {...primaryProps}
              className="tutorial-tooltip-footer_next"
              id={step.nextid}
            >
              {isLast ? (
                <>
                  {step.buttonText ? (
                    step.buttonText
                  ) : (
                    <Trans i18nKey="tutorials.tooltip.completed">
                      Completed
                    </Trans>
                  )}
                </>
              ) : (
                <Trans i18nKey="tutorials.tooltip.next">Next</Trans>
              )}
            </button>
          )}
        </div>
      </div>
    );
  },
  customToolTipSkincare: ({index, size, step, closeProps, tooltipProps}) => {
    return (
      <div
        {...tooltipProps}
        className="tutorial-tooltip"
        style={{width: step.styles.options.width && step.styles.options.width}}
      >
        <div className="tutorial-skincare-tooltip-content">
          {step.title && (
            <div className="tutorial-tooltip-content_title">{step.title}</div>
          )}
          <button type="button" className="btn btn-icon" {...closeProps}>
            <i className="fa fa-times" />
          </button>
        </div>
        {step.content && (
          <div className="tutorial-skincare-tooltip-content_desc">
            {step.content}
          </div>
        )}
      </div>
    );
  },
};
